export var PREFIX_CLS = 'ant-fullcalendar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/calendar/Constants.js
// module id = 280
// module chunks = 1